import React from 'react';
import { withStyles } from 'material-ui/styles';
import SearchResult from './search_result.js';
import Grid from 'material-ui/Grid';

const styles = theme => ({
});


class SearchResultGeneric extends SearchResult {
  render() {
    const classes = this.props.classes;
    return (
      <Grid container className={classes.result} spacing={0}>
        <Grid item xs={12}>
          <a className={'__link'} href={this.props.item.link}>
            <span className={'__type'}>
              Generic [{this.props.type}]
            </span>
          </a>
        </Grid>
        <Grid item xs={12}>
          <a className={'__link'} href={this.props.item.link}>
            <span className={'__title'}>
              {this.props.item.title}
            </span>
          </a>
        </Grid>
        <Grid item xs={12}>
          <a className={'__link'} href={this.props.item.link}>
            <span className={'__url'}>
              [{this.props.item.formattedUrl}]
            </span>
          </a>
        </Grid>
        <Grid item xs={12}>
          <a className={'__link'} href={this.props.item.link}>
            <span className={'__snippet'}>
              {this.props.item.snippet}
            </span>
          </a>              
        </Grid>
      </Grid>
    );
  }
 
  getMetatags(data, exclude){
    var metas = '';
    var meta = {};
    var m, prop, propT, type, i;
    if(data == null) return "";

    for(type in data){
      //if(exclude.indexOf(type) >= 0) continue;

      if(data[type].length > 0){
        for(i = 0; i < data[type].length; i++){
          m = data[type][i];

          for(prop in m){
            propT = type + "_" + String(i) +'_' + prop;
            metas += this.setProp(prop, m, propT, meta);
          }
        }        
      } else {
        m = data[type];
        for(prop in m){
          propT = type + "_" + String(i) +'_' + prop;
          metas += this.setProp(prop, m, propT, meta);
        }
      }
    }
    return metas;
  }

  setProp_(propName, source, target){
    return this.setProp(propName, source, propName, target);
  }

  setProp(propName, source, propTarget, target){
    if (source[propName]){
      target[propTarget] = source[propName];
      //delete source[propName];
      var data = target[propTarget];
      if(data.length > 10){
        data = data.substring(0, 10) + "...";  
      }
      return `[${propTarget}:${data}]`;
    }
    
    return "";
  }
}

export default withStyles(styles)(SearchResultGeneric);


// WEBPACK FOOTER //
// ./src/search/results/search_result_generic.js